import { jsx as _jsx } from "react/jsx-runtime";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useRetailerRoutingContext } from "@faire/retailer-visitor-shared/RetailerRoutingContextProvider";
import { useCategoryStore } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore";
import { PrunedFeaturedSideNavigation } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/LeftNav/__internal__/FeaturedCategoryNavigation/PrunedFeaturedSideNavigation";
import { getLeftNavLinks } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/LeftNav/__internal__/LeftNavigationLinkHelpers/productBasedNavigationLinkHelpers";
import { LeftNavInner } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/LeftNav/__internal__/LeftNavInner";
import { filterLinksToVisibleNodes } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/LeftNav/__internal__/leftNavLinkAdapters";
import React, { useMemo } from "react";
export var LeftCategoryNavigation = function(param) {
    var selectedCategory = param.selectedCategory;
    var categories = useCategoryStore().categories;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var routingContext = useRetailerRoutingContext();
    var leftNavLinks = useMemo(function() {
        var _selectedCategory_mostSpecificPathIdentifier;
        return filterLinksToVisibleNodes(getLeftNavLinks(categories !== null && categories !== void 0 ? categories : [], selectedCategory, routingContext), (_selectedCategory_mostSpecificPathIdentifier = selectedCategory.mostSpecificPathIdentifier) !== null && _selectedCategory_mostSpecificPathIdentifier !== void 0 ? _selectedCategory_mostSpecificPathIdentifier : "");
    }, [
        categories,
        selectedCategory,
        routingContext
    ]);
    if (leftNavLinks.length > 0) {
        return /*#__PURE__*/ _jsx(LeftNavInner, {
            options: leftNavLinks,
            selectedIdentifier: selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.mostSpecificPathIdentifier
        });
    }
    if (isLoggedInRetailer) {
        return /*#__PURE__*/ _jsx(PrunedFeaturedSideNavigation, {});
    }
    return null;
};
